import React from 'react';
import { AppTheme } from '../types';
import './Modal.css';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  theme: AppTheme;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, theme }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal-content ${theme.isDark ? 'dark' : 'light'}`} onClick={(e) => e.stopPropagation()}>
        <div className={`modal-header ${theme.isDark ? 'dark' : 'light'}`}>
          <h3 className={`modal-title ${theme.isDark ? 'dark' : 'light'}`}>{title}</h3>
          <button className={`modal-close-button ${theme.isDark ? 'dark' : 'light'}`} onClick={onClose}>
            ×
          </button>
        </div>
        <div className={`modal-body ${theme.isDark ? 'dark' : 'light'}`}>
          {children}
        </div>
      </div>
    </div>
  );
};